<template>
  <div
    class="forms"
    :style="{
      background: `url(${itemData.backgroundUrl}?x-oss-process=image/resize,w_750/quality,q_80) top center / 100% auto no-repeat`,
      padding: `${computedStyle(itemData.padding.top)}px ${computedStyle(
        itemData.padding.right
      )}px ${computedStyle(itemData.padding.bottom)}px ${computedStyle(
        itemData.padding.left
      )}px`,
    }"
  >
    <div class="form_box" id="formBox">
      <van-form :validate-first="true">
        <van-field
          v-model.trim="infoForm.name"
          placeholder="请输入您的姓名"
          :maxlength="10"
          :style="{
            height: `${computedStyle(itemData.form.height)}px`,
            marginBottom: `${computedStyle(itemData.form.marginBottom)}px`,
          }"
        />
        <van-field
          v-model.trim="infoForm.telphone"
          placeholder="请输入手机号码"
          :maxlength="11"
          :style="{
            height: `${computedStyle(itemData.form.height)}px`,
            marginBottom: `${computedStyle(itemData.form.marginBottom)}px`,
          }"
        />
        <van-field
          v-model.trim="infoForm.codes"
          center
          clearable
          placeholder="请输入验证码"
          :maxlength="6"
          :style="{
            height: `${computedStyle(itemData.form.height)}px`,
            marginBottom: `${computedStyle(itemData.form.marginBottom)}px`,
          }"
        >
          <template #button>
            <van-button
              class="send-btn"
              :round="Boolean(itemData.form.isRound)"
              :style="{
                color: itemData.form.btnColor,
                background: itemData.form.btnbg,
              }"
              size="mini"
              :disabled="isSend"
              type="info"
              @click="sendSms"
              >{{ isSend ? `${num}s` : smsText }}</van-button
            >
          </template>
        </van-field>
        <van-field
          readonly
          clickable
          name="area"
          :value="infoForm.location"
          placeholder="请选择所在城市"
          @click="showArea = true"
          :style="{
            height: `${computedStyle(itemData.form.height)}px`,
            marginBottom: `${computedStyle(itemData.form.marginBottom)}px`,
          }"
        >
          <template #right-icon>
            <van-icon name="aim" @click.stop="handleGetLocation" />
          </template>
        </van-field>
        <van-popup v-model="showArea" position="bottom">
          <van-area
            :area-list="areaList"
            @confirm="onConfirm"
            @cancel="showArea = false"
            :columns-num="3"
          />
        </van-popup>
        <div class="protect" v-if="Boolean(itemData.form.showTreaty)">
          <van-checkbox v-model="checked"
            ><span class="label"
              >勾选表示同意
              <b
                class="label"
                @click.stop="
                  () => {
                    show = true;
                  }
                "
                >《个人信息授权与保护声明》</b
              >
            </span></van-checkbox
          >
        </div>
        <div>
          <van-button
            class="bg-btn"
            block
            :round="Boolean(itemData.form.isRound)"
            :style="{
              color: itemData.form.btnColor,
              height: `${itemData.form.btnHeight || 40}px`,
              background: itemData.form.btnImg
                ? `transparent url(${itemData.form.btnImg}?x-oss-process=image/resize,w_750/quality,q_80) no-repeat center center / contain`
                : `${itemData.form.btnbg}`,
            }"
            type="info"
            native-type="submit"
            @click="onSubmit"
            data-sensors-click
            name="submit-click"
            >{{ itemData.form.btnText }}</van-button
          >
        </div>
      </van-form>
      <van-dialog v-model="show" title="个人信息授权与保护声明">
        <div v-html="agreeMent" class="content"></div>
      </van-dialog>
    </div>
  </div>
</template>
<script>
import { areaList } from "@vant/area-data";
import {
  sendMessege,
  verifySnsCode,
  receivejson,
  appCityinfoGet,
} from "@/api/common.js";
import { nameReg, phoneReg } from "@/utils/validateReg.js";
import { randomString, MapLoader, getLocation } from "@/utils";
import agreeMent from "@/utils/privacyAgreement";

const initForm = () => {
  return {
    name: "",
    telphone: "",
    codes: "",
    location: "",
  };
};

export default {
  props: {
    itemData: {
      type: Object,
      default: () => ({
        padding: {
          top: "0",
          right: "30",
          bottom: "0",
          left: "30",
        },
      }),
    },
    title: {
      type: String,
      default: "DeRUCCI 慕思",
    },
    activityUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      infoForm: initForm(),
      checked: false,
      areaList,
      showArea: false,
      show: false,
      loading: false,
      smsText: "发送验证码",
      isSend: false,
      num: 60,
      timer: null,
      agreeMent,
    };
  },
  created() {},
  mounted() {
    if (this.$route.query.assetsId && this.$route.query.source == "douyin") {
      // eslint-disable-next-line no-undef
      _baq.track("page_view", {
        assets_id: this.$route.query.assetsId,
        view_page_url: location.href,
      });
    }

    this.handleGetLocation();
  },
  methods: {
    handleGetLocation() {
      getLocation().then(async (position) => {
        const { data = {} } = await appCityinfoGet(position);
        this.infoForm.location = `${data.province}/${data.city}`;
      });
    },
    computedStyle(num) {
      return (num * document.documentElement.clientWidth) / 323;
    },
    sendSms() {
      const { telphone } = this.infoForm;
      if (!telphone) {
        this.$toast("手机号码必填");
        return;
      }
      if (!phoneReg.test(telphone)) {
        this.$toast("手机号码格式不正确");
        return;
      }
      if (!this.isSend) {
        const params = {
          project: this.title, // 调用项目：CRM
          phone: telphone, // 调用电话：多个时用分号隔开，上限500个
          sender: 8822072204468,
          signName: "慕思", // 签名：慕思
          tempCode: "010bffe48c3d46d7bf837fa3eb084134", // 模板code: SMS_182541596
          operType: "CAPTCHA", // 操作类型：CAPTCHA 验证码类短信、NOTE 通知类短信
          tempParam: "{}", // 模板中的变量，json字符串，验证码code非空时，直接进行验证码处理，验证码code为空时，由接口自动生成
          mhzTime: 1, // 验证码发送频率时长，范围：1分钟~2分钟，默认：1分钟
          validTime: 5, // 验证码有效时间，范围：5分钟~30分钟，默认：5分钟
        };
        this.isSend = true;
        sendMessege(params).then((res) => {
          this.$toast(res.msg);
        });
        this.timer = setInterval(() => {
          if (this.num > 0) {
            this.num--;
          } else {
            clearInterval(this.timer);
            this.isSend = false;
            this.num = 60;
          }
        }, 1000);
      }
    },
    async onSubmit() {
      const { name, telphone, location, codes } = this.infoForm;
      const adress = location.split("/");

      if (!name) {
        this.$toast("姓名必填");
        return;
      }
      if (!telphone) {
        this.$toast("手机号码必填");
        return;
      }
      if (!codes) {
        this.$toast("验证码必填");
        return;
      }
      if (!location) {
        this.$toast("所在城市必填");
        return;
      }
      if (!nameReg.test(name)) {
        this.$toast("姓名格式不正确");
        return;
      }
      if (!phoneReg.test(telphone)) {
        this.$toast("手机号码格式不正确");
        return;
      }

      if (this.itemData.form.showTreaty && !this.checked) {
        this.$toast("请勾选并同意个人信息授权与保护声明");
        return;
      }

      try {
        const { code, msg } = await verifySnsCode({
          phone: telphone,
          verifyCode: codes,
        });

        if (code != 0) {
          this.$toast(msg);
          return;
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
        return;
      }

      const data = {
        ad_id: this.$route.query.confId, //专题页id
        external_url:  window.location.href, //投放url
        gender: "未知", //性别：男/女/未知
        create_time: +new Date() + "", //创建时间
        telphone, //手机号码
        ad_name: this.title, // 专题页名称
        name, //姓名
        province: adress[0], //省
        city: adress[1], //城市
        area: adress[2], //地区
        id: randomString(18), //线索id
      };

      receivejson(data)
        .then((res) => {
          if (res.code == 0) {
            this.$toast("提交成功");
            this.infoForm = initForm();
            const params = {
              name: name,
              phone_num: btoa("5345" + telphone + "74826"),
              province: adress[0],
              city: adress[1],
            };

            try {
              this.$sensors.login(btoa("5345" + telphone + "74826"));
              //神策
              this.$sensors.track("SubMitInfor", params);
              this.$sensors.setProfile({
                nick_name: name,
                phone: btoa("5345" + telphone + "74826"),
                resuster_time: +new Date(),
              });

              // 抖音广告
              if (
                this.$route.query.assetsId &&
                this.$route.query.source == "douyin"
              ) {
                //"1718658484712452"
                // eslint-disable-next-line no-undef
                _baq.track("form", {
                  assets_id: this.$route.query.assetsId,
                  ...params,
                  phone_num: telphone,
                });
              }

              //快手
              if (
                this.$route.query.convertId &&
                this.$route.query.source == "kuaishou"
              ) {
                // eslint-disable-next-line no-undef
                _ks_trace.push({
                  event: "form",
                  convertId: this.$route.query.convertId,
                  cb: function () {
                    // eslint-disable-next-line no-console
                    console.log("Your callback function here!");
                  },
                });
              }

              //b站
              if (this.$route.query.source == "bilibili") {
                window.bilicm.mbase.report_data();
              }
            } catch (err) {
              // eslint-disable-next-line no-console
              console.log(err);
            }
          } else {
            this.$toast(res.message);
          }
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err);
          this.$toast("提交失败");
        });
    },
    onConfirm(values) {
      let strArr = [];
      values.map((item) => {
        strArr.push(item.name);
      });
      this.infoForm.location = strArr.join("/");
      this.showArea = false;
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .van-form {
  .van-field__value {
    display: flex;
  }

  .van-field__body {
    width: 100%;
  }

  .van-cell {
    background: #fff;
    border: none;
    margin-bottom: 15px;
    padding: 5px 20px;
    border-radius: 5px;
    font-size: 12px;

    .van-field__label {
      color: #8d8d8d;
    }
  }

  .van-field__control {
    color: #000;
  }

  .van-cell .van-button--info {
    background-color: #1989fa;
    border-color: #1989fa;
  }

  .van-checkbox__label {
    margin-left: 0;

    .label {
      font-size: 12px;
      font-weight: bold;
      color: #1989fa;
      line-height: 1;
      display: flex;
      align-items: center;
      margin-left: 0;
    }
  }

  .van-checkbox {
    display: flex;
    align-items: center;
  }

  .van-checkbox__icon {
    transform: scale(0.7);
  }

  input::-webkit-input-placeholder {
    color: #c3c3c3;
  }

  .van-checkbox__label {
    display: flex;
    align-items: center;
    font-size: 10px;
  }

  .van-checkbox__icon {
    width: 14px;
    height: 14px;
    line-height: 14px;
  }

  .van-checkbox__icon .van-icon {
    width: 14px;
    height: 14px;
    line-height: 14px;
    font-size: 12px;
  }
}

::v-deep {
  .content {
    height: 400px;
    overflow-y: auto;
    padding: 10px;
    font-size: 12px;
    line-height: 1.5;
    white-space: wrap;

    h1 {
      font-size: 14px;
      text-align: center;
    }

    p {
      padding: 5px;
      margin: 0;
    }
  }
}

// .forms {
//   background-repeat: no-repeat;
//   background-size: 100% auto;
// }
.report {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  height: 50px;
  width: 100%;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
  background-color: #395cce;
  color: #fff;
}

.bg-btn {
  //   background: url(~@/assets/818/按钮.png) center center no-repeat;
  background-size: contain;
  border: none;
  height: 40px;
}

.send-btn {
  border: none;
}

.img {
  display: block;
  margin: 0 auto;
  width: 100%;
}

.van-cell::after {
  border: none;
}

.van-button--normal {
  font-size: 20px;
  font-weight: bold;
}

.protect {
  margin-bottom: 10px;
  display: flex;
  /* flex-direction: row; */
  align-items: center;
}

.label {
  color: #8d8d8d;
}

.explain {
  font-size: 12px;
  margin-top: 20px;
  color: #27447e;
  text-align: center;
}
</style>
